import { captureException } from '@sentry/react-native';
import { TFunction } from 'i18next';
import { FieldError, FieldValues, SubmitErrorHandler } from 'react-hook-form';
import { showToast } from '_utils';
import getTranslatedFormErrorMessage from './getTranslatedFormErrorMessage';

const handleInvalidSubmit =
    <FormValues extends FieldValues>(t: TFunction): SubmitErrorHandler<FormValues> =>
    (errors) => {
        const firstError = Object.values(errors).find((error) => error !== undefined);

        if (firstError) {
            captureException(new Error(`Validation error: ${JSON.stringify(errors)}`), {
                extra: {
                    errors,
                },
            });

            const header =
                getTranslatedFormErrorMessage(firstError as FieldError, t) ?? (firstError?.message as string) ?? '';
            showToast({
                type: 'error',
                header,
                text: t('global:task_failed_description'),
            });
        } else {
            captureException(new Error('No validation errors'));
            showToast({
                type: 'error',
                header: t('global:task_failed_header'),
                text: t('global:task_failed_description'),
            });
        }
    };

export default handleInvalidSubmit;
